"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCoveringPopover = void 0;
var popover_1 = require("@reach/popover");
var react_1 = __importDefault(require("react"));
var clonePRect_1 = require("../util/clonePRect");
var removePx_1 = require("../util/removePx");
function useCoveringPopover(popoverMinWidth) {
    var position = react_1.default.useCallback(function (targetRect, popoverRect) {
        if (targetRect && popoverRect) {
            var customPopoverRect = (0, clonePRect_1.clonePRect)(popoverRect);
            var popoverWidth = popoverMinWidth
                ? Math.max(popoverMinWidth, targetRect.width)
                : popoverRect.width;
            customPopoverRect.width = popoverWidth;
            var calculated = (0, popover_1.positionDefault)(targetRect, customPopoverRect);
            calculated.width = popoverWidth;
            var calculatedTopNum = (0, removePx_1.removePx)(calculated.top);
            if (calculatedTopNum) {
                // adjust default position to make the popover
                // cover the field instead of being beside it
                if (calculatedTopNum > targetRect.top) {
                    calculated.top = calculatedTopNum - targetRect.height;
                }
                else {
                    calculated.top = calculatedTopNum + targetRect.height;
                }
            }
            return calculated;
        }
        return (0, popover_1.positionDefault)(targetRect, popoverRect);
    }, [popoverMinWidth]);
    return { position: position };
}
exports.useCoveringPopover = useCoveringPopover;
